import { connect } from 'react-redux'

import { WGS_HOW_IT_WORKS } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './WgsHowItWorks'

const LocalizedComponent = withLocalization(Component, WGS_HOW_IT_WORKS)

export default connect(null, null)(LocalizedComponent)
